<script>
import { mapState } from "vuex";

import orderMixin from "@/mixins/orderMixin";

export default {
  mixins: [orderMixin],

  computed: {
    ...mapState("payable", ["payable"])
  }
};
</script>

<template>
  <div class="order-details">
    <h4>Detalhes do agendamento</h4>

    <p>
      Limpeza de <span>{{ payable | getOrderDuration }}</span> no dia <span>{{ payable | getOrderScheduleDay }}</span> com o(a) profissional <span>{{ payable | getOrderProfessionalFullName }}</span> no endereço <span>{{ payable | getOrderAddressName }}</span>.
    </p>

    <div class="amount">{{ payable | getOrderAmount }}</div>
  </div>
</template>

<style scoped>
.order-details {
  border-bottom: solid 1px #e2e2e2;
  margin-bottom: 8px;
  padding-bottom: 8px;
}

h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  color: #424242;
}

p {
  margin: 8px 0;
  font-size: 13px;
  font-weight: 300;
  color: #888;
  text-align: justify;
}

span {
  font-weight: 500;
}

.amount {
  width: 100%;
  font-weight: 500;
  text-align: end;
  color: #424242;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payable/OrderComponents/OrderDetails.vue